import { useState, useEffect, useContext } from 'react'
import AuthContext from 'contexte/AuthContext'
import PageLoader from 'components/pageLoader/PageLoader'
import Tableau from 'components/DataComponents/Tableau/Tableau'
import './AgbkUserPositions.css'
import { useTranslation } from 'react-i18next';
import Notification from 'components/notifications/Notification'
import TickerImage from 'components/DataComponents/TickerImage/TickerImage'
import Modal from 'components/modal/Modal';
import Badge from 'components/Badge/Badge'
import colors from 'assets/colors'
import { fetchAgoPositions } from 'services/agoServices'

const AgbkUserPositions = ({ id }) => {

  const { user } = useContext(AuthContext)
  const { t } = useTranslation()

  const [loading, setLoading] = useState(true)
  const [portfolio, setPortfolio] = useState([])
  const [page, setPage] = useState(0)
  const [fetchLimit, setFetchLimit] = useState(10)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [closeMarginPositionData, setCloseMarginPositionData] = useState({})

  const tableHeaders = ['Ticker', 'Quantité']

  const transformeDataToTbody = (data) => {
    return data.length && data.map((item, index) => {
      if (!item) return { data: [] }


      return {
        data: [
          <TickerImage ticker={item.ticker} />,
          item.qty
        ],
      }
    })
  }

  const openModal = (index) => {
    setCloseMarginPositionData(portfolio[index]);
    setIsModalOpen(true)
  }


  const fetchData = async () => {
    try {
      const data = await fetchAgoPositions(user, id, page, fetchLimit)
      setPortfolio(data)
      setLoading(false)
    } catch {
      console.log('error')
    }
  }

  useEffect(() => {
    fetchData()
  }, [page])

  return (
    <div>
      {
        !loading ? (
          <div>
            <Notification />
            <Tableau
              tbody={transformeDataToTbody(portfolio)}
              thead={tableHeaders}
              limit={fetchLimit}
              pagination={true}
              setPage={setPage}
              page={page}
            />
          </div>
        ) : (
          <div className='pageLoaderBox'>
            <PageLoader />
          </div>
        )
      }
    </div>
  )
}

export default AgbkUserPositions